export class Dictionary {
    items = {};
    lenght=0;

    constructor() {
      this.items = {};
    }
    public has(key) {
      return key in this.items;
    }
    public add(key,value) {
      this.items[key] = value;
      this.lenght=this.lenght+1;
    }
    public set(key,value) {
      this.items[key] = value;
    }
    public get(key) {
      return this.items[key];
    }
    public delete(key) {
      if( this.has(key) ){
        delete this.items[key]
        this.lenght=this.lenght-1;
        return true;
      }
      return false;
    }
    // public isEmpty(){
    //   return this.items[0]==null;
    // }
}